var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "RewardCardList",
      "extra-items": [{
        text: _vm.rewardCard.title,
        to: 'RewardCardView',
        params: _vm.$route.params.reward_card_id
      }, {
        text: '集點任務',
        to: 'RewardMissionList',
        params: _vm.$route.params.reward_card_id
      }, {
        text: _vm.rewardMission.title
      }, '點數紀錄']
    }
  })], 1)]), _c('b-card', [_c('PointLog', {
    attrs: {
      "show-filter": false,
      "upper-target-type": "RewardMission",
      "upper-target-id": _vm.rewardMissionId,
      "prefix-file-name": _vm.rewardMission.title
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }